import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CanActivateTituloReceber } from './can-activate-titulo-receber';
import { TituloReceberViewContainerComponent } from './view/container';
''


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateTituloReceber],
                children: [
                    {path: '', component: TituloReceberViewContainerComponent}
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateTituloReceber
    ]
})
export class TituloReceberRoutingModule { }
